import axios from 'axios';
import { toast } from 'react-toastify';
import { getConfig, getUserToken } from '../util/helper';

let mensagemExibida = false;

const convertTokenServiceKey = (service) => {
  const services = {
    smartAPI: 'smart_api',
    smartLedger: 'smart_ledger',
  };
  return !!services[service] ? services[service] : service;
};

const api = async (service) => {
  const config = await getConfig(service);

  const tokenKey = convertTokenServiceKey(service);
  const tokenAuthorization = getUserToken(tokenKey)
    ? `bearer ${getUserToken(tokenKey)}`
    : '';

  const xAccessToken = getUserToken('Authenticated')
    ? `${getUserToken('Authenticated')}`
    : '';

  const client = axios.create({
    headers: {
      Authorization: tokenAuthorization,
      'x-access-token': xAccessToken,
      idaplicacao: config.idAplicacao,
      idcliente: config.idCliente
    },
    baseURL: config.baseUrl,
    validateStatus: (status) => {
      if (status < 500 && status !== 401) return true;
    },
  });

  return {
    post: (url, data, config) => {
      return client
        .post(url, data, config)
        .then((result) => {
          if (result?.data?.errors?.length > 0) {
            console.log('true');
            result.data.errors.forEach((error) => {
              toast.error(error);
            });
            return [];
          }

          return result;
        })
        .catch((error) => {
          const err = checkExpiredLogin(error);
          return err;
        });
    },
    put: (url, data, config) => {
      return client
        .put(url, data, config)
        .then((result) => {
          if (result?.data?.errors?.length > 0) {
            result.data.errors.forEach((error) => {
              toast.error(error);
            });
            return [];
          }

          return result;
        })
        .catch((error) => {
          const err = checkExpiredLogin(error);
          return err;
        });
    },
    get: (url, data) => {
      return client
        .get(url, data)
        .then((result) => {
          if (result.data.errors) {
            result.data.errors.forEach((error) => {
              if (error.msg) toast.error(error.msg);
              else toast.error(error);
            });
            return [];
          }
          return result;
        })
        .catch((error) => {
          let err = checkExpiredLogin(error);
          throw err;
        });
    },
    getProposta: (url, data) => {
      return client
        .get(url, data)
        .then((result) => {
          console.log(result)
          if (result.data.errors) {
            throw result?.data?.errors;
          }

          return result;
        })
        .catch((error) => {
          let err = checkExpiredLogin(error);
          throw err;
        });
    },
    delete: (url, data) => {
      return client
        .delete(url, data)
        .then((result) => {
          if (result.data.errors) {
            result.data.errors.forEach((error) => {
              toast.error(error);
            });
            return [];
          }

          return result;
        })
        .catch((error) => {
          let err = checkExpiredLogin(error);
          return err;
        });
    },
  };
};

function checkExpiredLogin(error) {
  if (error.response && error.response.status === 401) {
    if (!mensagemExibida) {
      mensagemExibida = true;
      toast.error('Sua sessão expirou, faça login novamente.', 2000);
    }

    setTimeout(() => {
      window.location.href = `#/login`;
    }, 2000);
  } else {
    const message = error.response ? error.response?.data : error.response?.data?.msg
    message && toast.error(message);
  }
  return error;
}

export default api;
